import { render } from "./ImportanciaFiscalizacao.vue?vue&type=template&id=709b491a"
import script from "./ImportanciaFiscalizacao.vue?vue&type=script&lang=js"
export * from "./ImportanciaFiscalizacao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__